// i18n for the R₿L Vault (ES / EN / SK).
export const VAULT_I18N = {
  es: {
    title: "R₿L Vault",
    subtitle: "Deposita R₿L y gana con los ingresos de la academia",
    tvl: "Total depositado",
    monthlyYield: "Yield este mes",
    depositors: "Depositantes",
    estimatedAPY: "APY estimado",
    deposit: "Depositar R₿L",
    withdraw: "Retirar",
    withdrawAll: "Retirar todo",
    myDeposit: "Mi depósito",
    myYield: "Yield acumulado",
    nextDistribution: "Próxima distribución",
    earlyWithdrawWarning: "Retirada anticipada: fee del 5% en depósitos con menos de 30 días",
    minDeposit: "Mínimo 100,000 R₿L",
    yieldHistory: "Historial de distribuciones",
    howItWorks: "Cómo funciona",
    howItWorksText:
      "20% de cada pago PRO en R₿L va al Vault y se distribuye mensualmente entre todos los depositantes activos. No es staking especulativo — es yield respaldado por ingresos reales del negocio.",
    connectWallet: "Conectar wallet",
    balance: "Balance",
    firstYield: "Primer yield estimado",
    depositSuccess: "¡Depósito registrado!",
    withdrawSuccess: "Retirada enviada a tu wallet",
    processing: "Procesando en Base L2…",
    walletConfirm: "Confirma en tu wallet…",
    loginFirst: "Inicia sesión para usar el Vault",
    estimated: "estimado · no garantizado",
    period: "Período",
    totalYield: "Yield total",
    myShare: "Mi parte",
    viewTx: "TX",
    empty: "Aún no hay distribuciones — la primera será el día 1 del próximo mes",
    noDeposit: "No tienes depósitos activos",
    fee: "Fee",
    net: "Neto recibido",
    amount: "Cantidad",
    selectWallet: "Selecciona tu wallet",
    disconnect: "Desconectar wallet",
    wrongNet: "Cambia a Base L2",
    switchBase: "Cambiar a Base",
    days: "d",
    hours: "h",
    available: "Disponible",
    eligibleAt: "Sin fee desde",
    error: "Error",
    retry: "Reintentar",
  },
  en: {
    title: "R₿L Vault",
    subtitle: "Deposit R₿L and earn from academy revenue",
    tvl: "Total deposited",
    monthlyYield: "This month yield",
    depositors: "Depositors",
    estimatedAPY: "Estimated APY",
    deposit: "Deposit R₿L",
    withdraw: "Withdraw",
    withdrawAll: "Withdraw all",
    myDeposit: "My deposit",
    myYield: "Accumulated yield",
    nextDistribution: "Next distribution",
    earlyWithdrawWarning: "Early withdrawal: 5% fee on deposits younger than 30 days",
    minDeposit: "Minimum 100,000 R₿L",
    yieldHistory: "Distribution history",
    howItWorks: "How it works",
    howItWorksText:
      "20% of every PRO payment in R₿L goes to the Vault and is distributed monthly among all active depositors. Not speculative staking — yield backed by real business revenue.",
    connectWallet: "Connect wallet",
    balance: "Balance",
    firstYield: "Estimated first yield",
    depositSuccess: "Deposit recorded!",
    withdrawSuccess: "Withdrawal sent to your wallet",
    processing: "Processing on Base L2…",
    walletConfirm: "Confirm in your wallet…",
    loginFirst: "Log in to use the Vault",
    estimated: "estimated · not guaranteed",
    period: "Period",
    totalYield: "Total yield",
    myShare: "My share",
    viewTx: "TX",
    empty: "No distributions yet — the first will be on the 1st of next month",
    noDeposit: "You have no active deposits",
    fee: "Fee",
    net: "Net received",
    amount: "Amount",
    selectWallet: "Select your wallet",
    disconnect: "Disconnect wallet",
    wrongNet: "Switch to Base L2",
    switchBase: "Switch to Base",
    days: "d",
    hours: "h",
    available: "Available",
    eligibleAt: "Fee-free from",
    error: "Error",
    retry: "Retry",
  },
  sk: {
    title: "R₿L Vault",
    subtitle: "Vlož R₿L a zarábaj z príjmov akadémie",
    tvl: "Celkom vložené",
    monthlyYield: "Výnos tento mesiac",
    depositors: "Vkladatelia",
    estimatedAPY: "Odhadovaný APY",
    deposit: "Vložiť R₿L",
    withdraw: "Vybrať",
    withdrawAll: "Vybrať všetko",
    myDeposit: "Môj vklad",
    myYield: "Nahromadený výnos",
    nextDistribution: "Ďalšie rozdelenie",
    earlyWithdrawWarning: "Predčasný výber: poplatok 5% pri vkladoch mladších ako 30 dní",
    minDeposit: "Minimum 100 000 R₿L",
    yieldHistory: "História distribúcií",
    howItWorks: "Ako to funguje",
    howItWorksText:
      "20% každej PRO platby v R₿L ide do Vaultu a mesačne sa rozdeľuje medzi všetkých aktívnych vkladateľov. Nie je to špekulatívny staking — výnos je krytý reálnymi príjmami.",
    connectWallet: "Pripojiť peňaženku",
    balance: "Zostatok",
    firstYield: "Odhadovaný prvý výnos",
    depositSuccess: "Vklad zaznamenaný!",
    withdrawSuccess: "Výber odoslaný do peňaženky",
    processing: "Spracúvanie na Base L2…",
    walletConfirm: "Potvrď v peňaženke…",
    loginFirst: "Prihlás sa pre použitie Vaultu",
    estimated: "odhad · nie je garantované",
    period: "Obdobie",
    totalYield: "Celkový výnos",
    myShare: "Môj podiel",
    viewTx: "TX",
    empty: "Zatiaľ žiadne distribúcie — prvá bude 1. deň budúceho mesiaca",
    noDeposit: "Nemáš aktívne vklady",
    fee: "Poplatok",
    net: "Čistá suma",
    amount: "Suma",
    selectWallet: "Vyber peňaženku",
    disconnect: "Odpojiť peňaženku",
    wrongNet: "Prepni na Base L2",
    switchBase: "Prepnúť na Base",
    days: "d",
    hours: "h",
    available: "Dostupné",
    eligibleAt: "Bez poplatku od",
    error: "Chyba",
    retry: "Skúsiť znova",
  },
  "zh-CN": {
    title: "R₿L Vault",
    subtitle: "存入 R₿L，从学院收入中获利",
    tvl: "总存款",
    monthlyYield: "本月收益",
    depositors: "存款人",
    estimatedAPY: "预估 APY",
    deposit: "存入 R₿L",
    withdraw: "提取",
    withdrawAll: "全部提取",
    myDeposit: "我的存款",
    myYield: "累计收益",
    nextDistribution: "下次分配",
    earlyWithdrawWarning: "提前提取：存款不足30天将收取5%手续费",
    minDeposit: "最低 100,000 R₿L",
    yieldHistory: "分配历史",
    howItWorks: "如何运作",
    howItWorksText: "每笔 PRO 会员 R₿L 支付的20%进入 Vault，并每月分配给所有活跃存款人。这不是投机性质押——而是由实际业务收入支撑的收益。",
    connectWallet: "连接钱包",
    balance: "余额",
    firstYield: "首次预估收益",
    depositSuccess: "存款已记录！",
    withdrawSuccess: "提取已发送至您的钱包",
    processing: "正在 Base L2 上处理…",
    walletConfirm: "请在您的钱包中确认…",
    loginFirst: "请先登录以使用 Vault",
    estimated: "预估值 · 不保证",
    period: "周期",
    totalYield: "总收益",
    myShare: "我的份额",
    viewTx: "TX",
    empty: "尚无分配记录——首次分配将在下月1日进行",
    noDeposit: "您没有活跃存款",
    fee: "手续费",
    net: "实际到账",
    amount: "数量",
    selectWallet: "选择您的钱包",
    disconnect: "断开钱包",
    wrongNet: "切换至 Base L2",
    switchBase: "切换至 Base",
    days: "天",
    hours: "小时",
    available: "可用",
    eligibleAt: "免手续费起始时间",
    error: "错误",
    retry: "重试",
  },
  de: {
    title: "R₿L Vault",
    subtitle: "Hinterlege R₿L und verdiene mit den Einnahmen der Academy",
    tvl: "Total hinterlegt",
    monthlyYield: "Yield diesen Monat",
    depositors: "Einzahler",
    estimatedAPY: "Geschätzter APY",
    deposit: "R₿L hinterlegen",
    withdraw: "Abheben",
    withdrawAll: "Alles abheben",
    myDeposit: "Meine Einlage",
    myYield: "Kumulierter Yield",
    nextDistribution: "Nächste Ausschüttung",
    earlyWithdrawWarning: "Vorzeitige Abhebung: 5% Gebühr bei Einlagen unter 30 Tagen",
    minDeposit: "Minimum 100.000 R₿L",
    yieldHistory: "Ausschüttungsverlauf",
    howItWorks: "Wie es funktioniert",
    howItWorksText: "20% jeder PRO-Zahlung in R₿L geht in den Vault und wird monatlich an alle aktiven Einzahler ausgeschüttet. Es ist kein spekulatives Staking — es ist Yield, der durch echte Geschäftseinnahmen unterstützt wird.",
    connectWallet: "Wallet verbinden",
    balance: "Guthaben",
    firstYield: "Erster geschätzter Yield",
    depositSuccess: "Einzahlung registriert!",
    withdrawSuccess: "Abhebung an deine Wallet gesendet",
    processing: "Verarbeitung auf Base L2…",
    walletConfirm: "Bestätige in deiner Wallet…",
    loginFirst: "Melde dich an, um den Vault zu nutzen",
    estimated: "geschätzt · nicht garantiert",
    period: "Zeitraum",
    totalYield: "Gesamter Yield",
    myShare: "Mein Anteil",
    viewTx: "TX",
    empty: "Noch keine Ausschüttungen — die erste erfolgt am 1. des nächsten Monats",
    noDeposit: "Du hast keine aktiven Einlagen",
    fee: "Gebühr",
    net: "Netto erhalten",
    amount: "Betrag",
    selectWallet: "Wähle deine Wallet",
    disconnect: "Wallet trennen",
    wrongNet: "Wechsle zu Base L2",
    switchBase: "Zu Base wechseln",
    days: "T",
    hours: "Std",
    available: "Verfügbar",
    eligibleAt: "Ohne Gebühr ab",
    error: "Fehler",
    retry: "Erneut versuchen",
  },
};

export const tVault = (lang, key) =>
  (VAULT_I18N[lang] || VAULT_I18N.es)[key] ?? VAULT_I18N.es[key] ?? key;
